// Utilitaire pour déterminer l'établissement actuel et ses couleurs

export type EtablissementType = 'lycee-francais' | 'lycee-ivoirien' | 'institut' | 'maternelle-primaire' | 'portail';

export interface EtablissementColors {
  primary: string;
  secondary: string;
  accent: string;
  background: string;
  text: string;
}

export const ETABLISSEMENT_COLORS: Record<EtablissementType, EtablissementColors> = {
  'lycee-francais': {
    primary: '#1E3A8A', // Bleu marine
    secondary: '#DC2626', // Rouge
    accent: '#D4AF37', // Or
    background: '#F8FAFC',
    text: '#1F2937'
  },
  'lycee-ivoirien': {
    primary: '#FF8C00', // Orange
    secondary: '#228B22', // Vert
    accent: '#FF8C00',
    background: '#FFFBF5',
    text: '#1F2937'
  },
  'institut': {
    primary: '#166534', // Vert foncé
    secondary: '#15803D', // Vert
    accent: '#22C55E',
    background: '#F0FDF4',
    text: '#1F2937'
  },
  'maternelle-primaire': {
    primary: '#9333EA', // Violet
    secondary: '#3B82F6', // Bleu
    accent: '#F97316', // Orange
    background: '#FAF5FF',
    text: '#1F2937'
  },
  'portail': {
    primary: '#166534',
    secondary: '#15803D',
    accent: '#22C55E',
    background: '#FFFFFF',
    text: '#1F2937'
  }
};

export function getEtablissementFromPath(pathname: string): EtablissementType {
  if (pathname.startsWith('/lycee-francais')) return 'lycee-francais';
  if (pathname.startsWith('/lycee-ivoirien')) return 'lycee-ivoirien';
  if (pathname.startsWith('/institut')) return 'institut';
  if (pathname.startsWith('/maternelle-primaire')) return 'maternelle-primaire';
  return 'portail';
}

export function getEtablissementColors(pathname: string): EtablissementColors {
  const etablissement = getEtablissementFromPath(pathname);
  return ETABLISSEMENT_COLORS[etablissement];
}
